module.exports = __webpack_public_path__ + "img/40.6c62f803.jpg";